import React from 'react';

import { IconProps } from '../types';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

import styles from '../Icons.module.scss';

const PendingIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <path
                d="M8.88 14.3667C8.66 14.3933 8.43333 14.4 8.2 14.4C4.77333 14.4 2 11.6267 2 8.2C2 4.77333 4.77333 2 8.2 2C10.7533 2 12.9467 3.54 13.8933 5.74667"
                stroke={color}
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M11.4467 13.4868C11.1734 13.6535 10.8934 13.8001 10.5934 13.9268"
                stroke={color}
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M13.3268 11.6997C13.1534 11.953 12.9668 12.193 12.7534 12.413"
                stroke={color}
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M14.3001 9.3335C14.2468 9.64016 14.1668 9.94016 14.0668 10.2268"
                stroke={color}
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M11.6666 5.66659L14.2 6.08928V3.15332"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M8.20001 4.68018V8.11733C8.20001 8.17038 8.17894 8.22125 8.14143 8.25875L6.40007 10.0002"
                stroke={color}
                strokeLinecap="square"
            />
        </svg>
    );
};

export default React.memo(PendingIcon);
